import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },

    {
      path: '/login',
      component: resolve => require(['@/components/login.vue'], resolve),
      meta: {
        title: '登陆'
      }
    },
    {
      path: '/tree',
      component: resolve => require(['@/components/mayi/tree.vue'], resolve),
      meta: {
        title: '缓冲页'
      }
    },
    {
      path: '/bottom',
      component: resolve => require(['../components/flex/bottom.vue'], resolve)
    },
    {
      path: '/404',
      component: resolve => require(['../components/common/404.vue'], resolve)
    },
    {
      path: '/403',
      component: resolve => require(['../components/common/403.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/404'
    },


   




  ],
  mode: 'history',
  base: '/manage/'
});


// const store = new Vuex.Store({
//   modules: modules,
// })


//全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.path == '/tree') {
      next();
  }else {
    let token = window.localStorage.getItem("token_trade_manage");
    //如果没登录,都导向登录页
    if (!token) {
      if (to.path !== '/login') {
        next({ path: '/login' })
      }else{
        next();
      }
    }else {
      next();
    }
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js